import React, { useContext, useState } from "react";
import { Context } from "../../../utils/context";
import ModalSave from "../../common/ModelSave";
import { CancelButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal, Button } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import { useForm, Controller } from "react-hook-form";

const AddOffCanvance = (props) => {
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const {
    register,
    control,
    handleSubmit,
    getValues,
    watch,
    formState: { errors },
  } = useForm({ defaultValues: { user: null, amount: "", description: "" } });
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const loadUsers = async (input) => {
    const response = await getData(
      `/common/masters/all-customers?&term=${input || ""}`,
    );
    return (response?.data || []).map((u) => ({
      value: u?.id,
      label: `${u?.name || "-"} (${u?.user_uid || "-"}${u?.affiliate_status ? " - Member" : ""})`,
      // label: `${u?.name || "-"} (${u?.user_uid || "-"}  )`,
    }));
  };

  // Runs only when the form is valid; opens the confirmation dialog
  const onValidSubmit = () => setShowConfirm(true);

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      const values = getValues();
      const finalData = new FormData();
      finalData.append("user_id", values.user.value);
      finalData.append("amount", values.amount);
      finalData.append("transaction_type", "credit");
      finalData.append(
        "description",
        values.description?.trim() || "Amount Credited By Admin",
      );

      const response = await postData(`/admin/wallet/transaction`, finalData);

      setShowConfirm(false);
      if (response?.success) {
        setShowModal({
          code: response.code,
          message: response.message || "Amount Credited",
        });
      } else {
        setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        setSubmitting(false);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
      setSubmitting(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Money
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form role="form" onSubmit={(e) => e.preventDefault()}>
            <Row className="d-flex justify-content-center">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>User</Form.Label>
                  <Controller
                    name="user"
                    control={control}
                    rules={{ required: "Please select a user" }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions
                        defaultOptions
                        loadOptions={loadUsers}
                        placeholder="Search user by name / UID"
                      />
                    )}
                  />
                  {errors.user && (
                    <span className="text-danger">{errors.user.message}</span>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Amount</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Amount..."
                      isInvalid={!!errors.amount}
                      {...register("amount", {
                        required: "Amount is required",
                        pattern: {
                          value: /^\d+(\.\d{1,2})?$/,
                          message: "Please enter a valid amount",
                        },
                        validate: (v) =>
                          Number(v) > 0 || "Amount must be greater than 0",
                      })}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "ArrowLeft",
                          "ArrowRight",
                          "Backspace",
                          "Tab",
                          "Delete",
                        ];
                        if (
                          !/[0-9.]/.test(e.key) &&
                          !allowedKeys.includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </InputGroup>
                  {errors.amount && (
                    <span className="text-danger">{errors.amount.message}</span>
                  )}
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Label>Description (optional)</Form.Label>

                  <Form.Control
                    as="textarea"
                    rows={2}
                    maxLength={250}
                    placeholder="Description..."
                    isInvalid={!!errors.description}
                    {...register("description")}
                  />

                  <small className="text-muted">Maximum 250 characters</small>

                  <Form.Control.Feedback type="invalid">
                    {errors.description?.message}
                  </Form.Control.Feedback>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <CancelButton
                    name={"cancel"}
                    handleClose={props.handleClose}
                  />
                  <button
                    className="btn btn-success ms-2"
                    type="button"
                    onClick={handleSubmit(onValidSubmit)}
                  >
                    Add Money
                  </button>
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showConfirm}
        onHide={() => !submitting && setShowConfirm(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Add ₹{watch("amount")} to the wallet of <b>{watch("user")?.label}</b>?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={submitting}
            onClick={() => setShowConfirm(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            disabled={submitting}
            onClick={handleConfirm}
          >
            {submitting ? "Adding..." : "Confirm"}
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
